<template>
<div class="chapter">
<div class="inner_page">
<p class="title_auth"><a id="page_iii"></a>From the author of <em class="italic">Left for Dead at Nijmegen</em>, 2019 Nonfiction Book of the Year.</p>
<p class="title_auth">“We found the narrative compelling.” Julie Huggins, <em class="italic">Smithsonian Books</em></p>
<h1 class="title">MIDNIGHT FLIGHT TO</h1>
<h1 class="title0">NUREMBERG</h1>
<h2 class="subtitle">The Capture of the Nazi who put Adolf Hitler into Power</h2>
<div class="img_containert">
<img alt="Image" src="images/piii_01.jpg"/>
</div>
<h3 class="auth1">MARCUS A. NANNINI</h3>
<div class="img_container">
<img alt="Image" src="images/piii_02.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?85f00c54